module.exports = __webpack_public_path__ + "static/slide2-73cb5b87f2d2f18d2dc7a973be2e4b01.jpg";